import index from "./list.vue";
export default index;
